/* eslint-disable */
export default {
  _intro: 'intro',
  _QuestionInstructions: 'QuestionInstructions',
  _vo_bonus_result: 'vo_bonus_result',
  _vo_correct1: 'vo_correct1',
  _vo_correct2: 'vo_correct2',
  _vo_incorrect1: 'vo_incorrect1',
  _vo_incorrect2: 'vo_incorrect2',
  _vo_lets_try_a_harder: 'vo_lets_try_a_harder',
  _vo_no_bonus_round: 'vo_no_bonus_round',
  _vo_play_bonus_round: 'vo_play_bonus_round',
  _vo_round_1_results: 'vo_round_1_results',
  _vo_round_2_results: 'vo_round_2_results',
  _vo_round_3_results: 'vo_round_3_results',
  _vo_you_finished_all: 'vo_you_finished_all',
}